module.exports = __webpack_public_path__ + "fonts/LatoLatin-Semibold.c27fb2c.ttf";